import 'jquery';
import 'fancybox';

import './functions/initApp';